import angular from 'angular';
import {
  actionIcon,
  alerts,
  confirmDialog,
} from 'app/components/global';
import {
  loaderService,
  ssDialogService,
  userService,

  assetSharedModelService,
  praDataService,
  praSharedModelService,
} from 'app/services';

import assetsByType from 'app/components/admin/assetAdministration/assetsByType';

import approvePRAProcessDialog from '../dialog.approvePRAProcessDialog';
import assignPRAAssetDialog from '../dialog.assignAssetDialog';
import editPraProcessDialog from '../dialog.editProcessDialog';

import processController from './process.controller';
import processDirective from './process.directive';


export default angular.module('app.components.advisory.pra.process', [
  actionIcon,
  alerts,
  confirmDialog,

  loaderService,
  ssDialogService,
  userService,

  assetSharedModelService,
  praDataService,
  praSharedModelService,

  assetsByType,

  approvePRAProcessDialog,
  assignPRAAssetDialog,
  editPraProcessDialog,
])
  .directive('praProcess', processDirective)
  .controller('PRAProcessController', processController)
  .name;

console.log('app.components.advisory.pra.process created');
